import React from "react";
import { Col, Row } from "antd";
import LOCALIZATION from "@Vytelle/authentication/src/services/LocalizationService";
import vytelleLogo from "@Vytelle/authentication/src/assets/images/vytelle-logo.svg";
import CreateUserSignUpForm from "./CreateUserSignUpForm";
import { FORM_STATUS } from "./SignUpUserDomain";
import "./style.scss";
import CreateUserSignUpMessage from "./CreateUserSignUpMessage";

function CreateUserSignUp() {
  const [status, setStatus] = React.useState(FORM_STATUS.IDLE);

  const body = React.useMemo(() => {
    if (status === FORM_STATUS.IDLE) {
      return (
        <CreateUserSignUpForm
          onSuccess={() => setStatus(FORM_STATUS.SUCCESS)}
          onError={() => setStatus(FORM_STATUS.ERROR)}
        />
      );
    }
    return (
      <CreateUserSignUpMessage
        status={status}
        onBack={() => setStatus(FORM_STATUS.IDLE)}
      />
    );
  }, [status]);

  return (
    <Row className="authentication-wrapper">
      <Col xs={0} sm={8} md={10} lg={10} xl={12} xxl={12} className="image-col">
        <a
          href={
            "https://vytelle.com/?utm_source=vytellesenseui&utm_medium=website&utm_campaign=alwaysprogressing&utm_term=ui"
          }
          target="_blank"
          rel="noopener noreferrer"
          className="btn"
        >
        </a>
      </Col>
      <Col
        xs={24}
        sm={16}
        md={14}
        lg={14}
        xl={12}
        xxl={12}
        className="form-col"
      >
        <img className="login-logo" src={vytelleLogo} alt="logo" />
        <div className="shadow-card">{body}</div>
        <div className="footer-links">
          <span>{LOCALIZATION.NEED_HELP}?</span>
          <a href="mailto:info@vytelle.com">
            {LOCALIZATION.CONTACT_CUSTOMER_SUPPORT}
          </a>
        </div>
      </Col>
    </Row>
  );
}

export default CreateUserSignUp;
